/**
商品列表
**/
<template>
	<div class="rightaside_content">
		<!-- 聊天弹窗开始 -->
		<el-dialog :title="kfname + '为您服务...'" center :visible.sync="dialogVisible" width="40%"
			:close-on-click-modal="false">
			<div class="dialogContent">
				<div class="chat-box" v-loading="loadingdialog">
					<div id="message-list">
						<div v-for="(message, index) in messages" :key="index">
							<div v-if="message.messageType == 0"
								:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
								<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
								<div class="divimg"><img :src="message.avatar" alt="" /></div>
								<div class="divtext" v-html="textfaceimg(message.content)"></div>
							</div>
							<div v-else-if="message.messageType == 3"
								:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
								<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
								<div class="divimg"><img :src="message.avatar" alt="" /></div>
								<div class="divtext">
									<div class="minicard">
										<div class="left"><img :src="JSON.parse(message.extend).image" alt="" /></div>
										<div class="right">
											<span>名称：<strong>{{JSON.parse(message.extend).goodsname}}</strong></span>
											<span>价格：<strong
													style="color:#D33A31;">￥{{JSON.parse(message.extend).price}}</strong></span>
											<span>订单号：{{JSON.parse(message.extend).orderNumber}}</span>
										</div>
									</div>
								</div>
							</div>
							<div v-else-if="message.messageType == 1"
								:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
								<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
								<div class="divimg"><img :src="message.avatar" alt="" /></div>
								<div class="divtext">
									<img style="width: 100px; height: 100px;" :src="message.extend.url" alt=""
										srcset="" />
								</div>
							</div>
							<div v-else-if="message.messageType == 5"
								:class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
								<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
								<div class="divimg"><img :src="message.avatar" alt="" /></div>
								<div class="divtext">
									<video controls style="width: 200px; height: 250px;">
										<source :src="message.extend.src" type="video/mp4">
									</video>
								</div>
							</div>
							<div v-else :class="message.fromId == userid ? 'rightmessage' : 'leftmessage'">
								<div class="divzt">{{message.readState == 'true' ? '已读' : '未读'}}</div>
								<div class="divimg"><img :src="message.avatar" alt="" /></div>
								<div class="divtext">
									<img :src="giffn(message.content)" alt="" />
								</div>
							</div>
						</div>
					</div>
					<div class="input-box">
						<transition name="el-zoom-in-bottom">
							<div class="imgbox" v-show="isdisplay">
								<img @click="isdisplay = !isdisplay,clickimg(item.img)" v-for="(item, index) in gifarr"
									:key="item.id" :src="require(`../../../static/layui/images/face/` + item.img)"
									alt="" />
							</div>
						</transition>
						<div class="textimgdiv">
							<div @click="isdisplay = !isdisplay"><img src="../../assets/images/pc/xiaolian.png"
									alt="" /></div>
							<input @change="handleFileChange" style="display: none;" type="file" name="file"
								ref="files" />
							<div @click="shangchuanimgfn"><img src="../../assets/images/pc/tupian.png" alt="" /></div>
							<input @change="handleFileMP4Change" style="display: none;" type="file" name="file"
								ref="mp4files" />
							<div @click="shangchuanmp4fn"><img style="height: 28px; width: 30px;"
									src="../../assets/images/pc/shipin.png" alt="" /></div>
						</div>
						<div class="minicard" v-if="isshowminicard">
							<div class="left"><img :src="goodspart.image" alt="" /></div>
							<div class="right">
								<span>名称：<strong>{{goodspart.goodsname}}</strong></span>
								<span>价格：<strong style="color:#D33A31;">￥{{goodspart.price}}</strong></span>
								<span>订单号：{{goodspart.orderNumber}}</span>
								<div class="dianjifs" @click="onegoodschat">点击发送</div>
							</div>
						</div>
						<input type="text" v-model="messageText" @keydown.enter="addMessage(0,messageText)"
							placeholder="请输入消息内容">
						<button @click="addMessage(0,messageText)">发送</button>
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 聊天弹窗结束 -->
		<h3 class="headerTitle">我的订单</h3>
		<el-tabs type="border-card" v-loading='loading' v-model="activeName" @tab-click="tabhandleClick">
			<el-tab-pane name=0>
				<span slot="label">全部有效订单</span>
				<div class="tab_pane_content">
					<div class="search_box">
						<el-input placeholder="请输入订单标题" v-model="allValue" class="input-with-select">
							<el-button slot="append" icon="el-icon-search" @click="searchHandle(allValue)"></el-button>
						</el-input>
					</div>
					<div v-for="(item,index) in orderInfoList" :key="index"
						:class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
						<div class="orderbox_info_header">
							<div style="width:80%">
								<p>{{(item.groupStatus&&item.groupStatus!=2)?'拼团中': orderStatus(item.status)}} </p>
								<p>{{item.commodityName}}</p>
								<span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
								<span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider
									direction="vertical"></el-divider>
								<span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider
									direction="vertical"></el-divider>
							</div>
							<div>
								<span class="order_money">订单金额：<i>{{item.totalMoney || 0.00}}</i> 元</span>
							</div>
						</div>
						<el-row class="order_goods_whole">
							<el-col :span="20" @click.native="gotoDetail(item)">
								<el-row class="order_goods" v-for="(goodsItem,index) in item.bxyCommodityList"
									:key="index">
									<el-col :span="2">
										<!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
										<el-image
											:src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`"
											class="bg" style="width: 62px; height: 62px">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</el-col>
									<el-col :span="15" class="order_Info_item">
										<!-- <p>{{goodsItem.specificationlist[0].attributeContent}}========</p> -->
										<p>{{goodsItem.name}} <span
												style="color:#ff6700">{{goodsItem.specificationlist.length>0&&goodsItem.specificationlist!=null?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span>
										</p>

										<p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
										<p style="color:rgb(255, 103, 0)"
											v-if="goodsItem.status == '31'||goodsItem.status == '32'||goodsItem.status == '33'||goodsItem.status == '34'">
											{{orderStatus(goodsItem.status)}}
										</p>
										<!-- <p>{{(item.price!=null && item.price!="")?item.price: item.marketprice}} * {{item.number || 1 }}</p> -->
									</el-col>

								</el-row>
							</el-col>
							<el-col :span="4" style="text-align: center;">
								<el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
								<el-button v-if="item.status==4&&item.commentStatus!=1" class="buttonStyle"
									@click="rework(item)">申请返修</el-button>
								<!--          <el-button  v-if="item.status==31&&item.serviceType==2" class="buttonStyle" >返修审核中</el-button>
								<el-button v-if="item.status==32&&item.commentStatus!=1" class="buttonStyle" >返修已经审核</el-button>
								<el-button v-if="item.status==33&&item.commentStatus!=1" class="buttonStyle" >返修完成</el-button> -->
								<!-- <p v-if="item.status==34&&item.commentStatus!=1" class="buttonStyle" @click="rework(item)">返修寄回</p> -->
								<el-button v-if="item.status==34&&item.commentStatus!=1"
									class="buttonStyle">再次申请返修</el-button>
								<!-- <el-button  v-if="item.status==4&&item.commentStatus!=1" class="buttonStyle" @click="rework(item)">申请返修</el-button> -->
								<el-button v-if="item.status==4&&item.commentStatus!=1" class="buttonStyle dangerBg"
									type="danger" @click="orderEvaluation(item)">订单评价</el-button>
								<el-button v-if="item.status==3?true:false" class="buttonStyle dangerBg" type="danger"
									@click="confirmRceipt(item)">确认收货</el-button>
								<el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger"
									@click="payOrderNow(item.amount,item)">立即支付</el-button>
								<el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger"
									@click="refund(item)">退款</el-button>
								<el-button v-if="item.status==1?true:false" class="buttonStyle" type="danger" plain
									@click="cancleOrder(item.oid)">取消订单</el-button>
								<el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain
									@click="removeOrder(item.oid)">移出订单</el-button>
								<el-button v-if="item.status==4?true:false" class="buttonStyle" type="danger" plain
									@click="addinvoice(item)">添加发票</el-button>
								<el-button class="buttonStyle" type="warning" plain
									@click="ToChat(item.bxyCommodityList,item)">联系客服</el-button>

							</el-col>
						</el-row>
					</div>
					<div class="noData" v-if="orderInfoList.length==0?true:false">
						您还没有相关订单。
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane name="1" label="待支付">
				<!-- <span slot="label">待支付</span> -->
				<span slot="label">待支付</span>
				<div class="tab_pane_content">
					<div class="search_box">
						<el-input placeholder="请输入订单标题" v-model="waitpayValue" class="input-with-select">
							<el-button slot="append" icon="el-icon-search"
								@click="searchHandle(waitpayValue)"></el-button>
						</el-input>
					</div>
					<div v-for="(item,index) in orderInfoList" :key="index"
						:class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
						<div class="orderbox_info_header">
							<div style="width:80%">
								<p>{{orderStatus(item.status)}}</p>
								<p>{{item.commodityName}}</p>
								<span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
								<span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider
									direction="vertical"></el-divider>
								<span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider
									direction="vertical"></el-divider>
							</div>
							<div>
								<span class="order_money">订单金额：<i>{{item.totalMoney || 0.00}}</i> 元</span>
							</div>
						</div>
						<el-row class="order_goods_whole">
							<el-col :span="20" @click.native="gotoDetail(item)">
								<el-row class="order_goods" v-for="(goodsItem,index) in item.bxyCommodityList"
									:key="index">
									<el-col :span="2">
										<!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
										<el-image
											:src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</el-col>
									<el-col :span="15" class="order_Info_item">
										<!-- <p>{{item.proTitle}}</p>{{item.specificationlist[0].name}}-->
										<p>{{goodsItem.name}} <span
												style="color:#ff6700">{{goodsItem.specificationlist.length>0&&goodsItem.specificationlist!=null?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span>
										</p>
										<p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
										<!-- <p>{{(item.price!=null && item.price!="")?item.price: item.marketprice}} * {{item.number || 1 }}</p> -->
									</el-col>

								</el-row>
							</el-col>
							<el-col :span="4">
								<el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
								<el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger"
									@click="payOrderNow(item.amount,item)">立即支付</el-button>
								<el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger"
									@click="refund(item)">退款</el-button>
								<el-button v-if="item.status==1?true:false" class="buttonStyle" type="danger" plain
									@click="cancleOrder(item.oid)">取消订单</el-button>
								<el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain
									@click="removeOrder(item.oid)">移出订单</el-button>
								<el-button class="buttonStyle" type="warning" plain
									@click="ToChat(item.bxyCommodityList)">联系客服</el-button>
							</el-col>
						</el-row>
					</div>

					<div class="noData" v-if="orderInfoList.length==0?true:false">
						您还没有相关订单。
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane name=2 label="待发货">
				<span slot="label">待发货</span>
				<div class="tab_pane_content">
					<div class="search_box">
						<el-input placeholder="请输入订单标题" v-model="waitSendValue" class="input-with-select">
							<el-button slot="append" icon="el-icon-search"
								@click="searchHandle(waitSendValue)"></el-button>
						</el-input>
					</div>
					<div v-for="(item,index) in orderInfoList" :key="index"
						:class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
						<div class="orderbox_info_header">
							<div style="width:80%">
								<p>{{orderStatus(item.status)}} </p>
								<p>{{item.commodityName}}</p>
								<span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
								<span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider
									direction="vertical"></el-divider>
								<span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider
									direction="vertical"></el-divider>
							</div>
							<div>
								<span class="order_money">订单金额：<i>{{item.totalMoney || 0.00}}</i> 元</span>
							</div>
						</div>
						<el-row class="order_goods_whole">
							<el-col :span="20" @click.native="gotoDetail(item)">
								<el-row class="order_goods" v-for="(goodsItem,index) in item.bxyCommodityList"
									:key="index">
									<el-col :span="2">
										<!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
										<el-image
											:src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</el-col>
									<el-col :span="15" class="order_Info_item">
										<!-- <p>{{item.proTitle}}</p>  {{item.specificationlist[0].name}}-->
										<p>{{goodsItem.name}} <span
												style="color:#ff6700">{{goodsItem.specificationlist.length>0&&goodsItem.specificationlist!=null?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span>
										</p>

										<p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
									</el-col>

								</el-row>
							</el-col>
							<el-col :span="4">
								<el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
								<!-- <el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger" @click="payOrderNow(item.amount,item)">立即支付</el-button>
                                        <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button>
                                        <el-button v-if="item.status==5?false:true" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button>
                                        <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(item.oid)">移出订单</el-button> -->
								<el-button class="buttonStyle" type="warning" plain
									@click="ToChat(item.bxyCommodityList)">联系客服</el-button>

							</el-col>
						</el-row>
					</div>
					<div class="noData" v-if="orderInfoList.length==0?true:false">
						您还没有相关订单。
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane name=3 label="待收货">
				<span slot="label">待收货</span>
				<div class="tab_pane_content">
					<div class="search_box">
						<el-input placeholder="请输入订单标题" v-model="waitGetValue" class="input-with-select">
							<el-button slot="append" icon="el-icon-search"
								@click="searchHandle(waitGetValue)"></el-button>
						</el-input>
					</div>
					<div v-for="(item,index) in orderInfoList" :key="index"
						:class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
						<div class="orderbox_info_header">
							<div style="width:80%">
								<p>{{orderStatus(item.status)}}</p>
								<p>{{item.commodityName}}</p>
								<span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
								<span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider
									direction="vertical"></el-divider>
								<span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider
									direction="vertical"></el-divider>
							</div>
							<div>
								<span class="order_money">订单金额：<i>{{item.totalMoney || 0.00}}</i> 元</span>
							</div>
						</div>
						<el-row class="order_goods_whole">
							<el-col :span="20" @click.native="gotoDetail(item)">
								<el-row class="order_goods" v-for="(goodsItem,index) in item.bxyCommodityList"
									:key="index">
									<el-col :span="2">
										<!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
										<el-image
											:src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</el-col>
									<el-col :span="15" class="order_Info_item">
										<!-- <p>{{item.proTitle}}</p> {{item.specificationlist[0].name}}-->
										<p>{{goodsItem.name}} <span
												style="color:#ff6700">{{goodsItem.specificationlist.length>0&&goodsItem.specificationlist!=null?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span>
										</p>
										<p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
									</el-col>

								</el-row>
							</el-col>
							<el-col :span="4">
								<el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
								<el-button v-if="item.status==3?true:false" class="buttonStyle dangerBg" type="danger"
									@click="confirmRceipt(item)">确认收货</el-button>
								<!-- <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button>
                                <el-button v-if="item.status==5?false:true" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button>
                                <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(item.oid)">移出订单</el-button> -->
								<el-button class="buttonStyle" type="warning" plain
									@click="ToChat(item.bxyCommodityList)">联系客服</el-button>

							</el-col>
						</el-row>
					</div>
					<div class="noData" v-if="orderInfoList.length==0?true:false">
						您还没有相关订单。
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane name=4 label="已完成">
				<span slot="label">已完成</span>
				<div class="tab_pane_content">
					<div class="search_box">
						<el-input placeholder="请输入订单标题" v-model="finishiValue" class="input-with-select">
							<el-button slot="append" icon="el-icon-search"
								@click="searchHandle(finishiValue)"></el-button>
						</el-input>
					</div>
					<div v-for="(item,index) in orderInfoList" :key="index"
						:class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
						<div class="orderbox_info_header">
							<div style="width:80%">
								<p>{{orderStatus(item.status)}}</p>
								<p>{{item.commodityName}}</p>
								<span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
								<span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider
									direction="vertical"></el-divider>
								<span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider
									direction="vertical"></el-divider>
							</div>
							<div>
								<span class="order_money">订单金额：<i>{{item.totalMoney || 0.00}}</i> 元</span>
							</div>
						</div>
						<el-row class="order_goods_whole">
							<el-col :span="20" @click.native="gotoDetail(item)">
								<el-row class="order_goods" v-for="(goodsItem,index) in item.bxyCommodityList"
									:key="index">
									<el-col :span="2">
										<!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
										<el-image
											:src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</el-col>
									<el-col :span="15" class="order_Info_item">
										<!-- <p>{{item.proTitle}}</p> {{item.specificationlist[0].name}}-->
										<p>{{goodsItem.name}} <span
												style="color:#ff6700">{{goodsItem.specificationlist.length>0&&goodsItem.specificationlist!=null?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span>
										</p>
										<p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
									</el-col>

								</el-row>
							</el-col>
							<el-col :span="4">
								<el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
								<el-button v-if="item.status==4&&item.commentStatus!=1" class="buttonStyle"
									@click="rework(item)">申请返修</el-button>
								<p v-if="item.status==32&&item.commentStatus!=1" class="buttonStyle">返修审核中</p>
								<p v-if="item.status==33&&item.commentStatus!=1" class="buttonStyle">返修完成</p>
								<p v-if="item.status==34&&item.commentStatus!=1" class="buttonStyle">返修寄回</p>
								<el-button v-if="item.status==4&&item.commentStatus!=1" class="buttonStyle dangerBg"
									type="danger" @click="orderEvaluation(item)">订单评价</el-button>
								<!-- <el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger" @click="payOrderNow(item.amount,item)">立即支付</el-button>
                                <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button>
                                <el-button v-if="item.status==5?false:true" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button>
                                <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(item.oid)">移出订单</el-button> -->
								<el-button class="buttonStyle" type="warning" plain
									@click="ToChat(item.bxyCommodityList)">联系客服</el-button>

							</el-col>
						</el-row>
					</div>
					<div class="noData" v-if="orderInfoList.length==0?true:false">
						您还没有相关订单。
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane name=5 label="已关闭">
				<span slot="label">已关闭</span>
				<div class="tab_pane_content">
					<div class="search_box">
						<el-input placeholder="请输入订单标题" v-model="closeValue" class="input-with-select">
							<el-button slot="append" icon="el-icon-search"
								@click="searchHandle(closeValue)"></el-button>
						</el-input>
					</div>
					<div v-for="(item,index) in orderInfoList" :key="index"
						:class="item.status==1?'orderbox_info redBorder':'orderbox_info'">
						<div class="orderbox_info_header">
							<div style="width:80%">
								<p>{{orderStatus(item.status)}}</p>
								<p>{{item.commodityName}}</p>
								<span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
								<span>{{item.shopName!=null?item.shopName:'--'}}</span> <el-divider
									direction="vertical"></el-divider>
								<span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider
									direction="vertical"></el-divider>
							</div>
							<div>
								<span class="order_money">订单金额：<i>{{item.totalMoney || 0.00}}</i> 元</span>
							</div>
						</div>
						<el-row class="order_goods_whole">
							<el-col :span="20" @click.native="gotoDetail(item)">
								<el-row class="order_goods" v-for="(goodsItem,index) in item.bxyCommodityList"
									:key="index">
									<el-col :span="2">
										<!-- <el-image :src="`${(item.photos!=undefined || item.photos!=null) ?item.photos:''}`"></el-image> -->
										<el-image
											:src="`${(goodsItem.photos!=undefined || goodsItem.photos!=null) ?goodsItem.photos:''}`">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</el-col>
									<el-col :span="15" class="order_Info_item">
										<!-- <p>{{item.proTitle}}</p>  {{item.specificationlist[0].name}}-->
										<p>{{goodsItem.name}} <span
												style="color:#ff6700">{{goodsItem.specificationlist.length>0&&goodsItem.specificationlist!=null?goodsItem.specificationlist[0].attributeContent:'默认规格'}}</span>
										</p>
										<p>{{goodsItem.price}} * {{goodsItem.number || 1 }}</p>
									</el-col>

								</el-row>
							</el-col>
							<el-col :span="4">
								<el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
								<!-- <el-button v-if="item.status==1?true:false" class="buttonStyle dangerBg" type="danger" @click="payOrderNow(item.amount,item)">立即支付</el-button>
                                <el-button v-if="item.status==2?true:false" class="buttonStyle dangerBg" type="danger" @click="$router.push('/myRefund')">退款</el-button>
                                <el-button v-if="item.status==5?false:true" class="buttonStyle" type="danger" plain  @click="cancleOrder(item.oid)">取消订单</el-button> -->
								<el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain
									@click="removeOrder(item.oid)">移出订单</el-button>
								<el-button v-if="item.status==4?true:false" class="buttonStyle" type="danger" plain
									@click="addinvoice(item.oid)">添加发票</el-button>
								<el-button class="buttonStyle" type="warning" plain
									@click="ToChat(item.bxyCommodityList)">联系客服</el-button>
							</el-col>
						</el-row>
					</div>
					<div class="noData" v-if="orderInfoList.length==0?true:false">
						您还没有相关订单。
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<el-row>
			<el-col :span="24" class="pagination">
				<!-- 分页组件 -->
				<Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
			</el-col>
		</el-row>
		<!-- 发票的弹框 -->
		<el-dialog :visible.sync="dialogInvoice" :destroy-on-close="true" :close-on-click-modal="false"
			@close="beforeClose" width="910px" class="dialogBox">
			<div v-show="showEditButtom ? false : true" class="textCenter">
				添加发票信息
			</div>
			<div v-show="showEditButtom ? true : false" class="textCenter">
				编辑发票信息
			</div>
			<span slot="footer" class="dialog-footer">
				<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="140px"
					class="demo-ruleForm">
					<el-form-item label="发票类型">
						<el-radio-group v-model="ruleForm.type">
							<el-radio label="1">电子发票(非纸质)</el-radio>
							<el-radio label="2">普通发票(纸质)</el-radio>
							<el-radio label="3">专用发票</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="抬头类型" v-if="ruleForm.type != 3">
						<el-radio-group v-model="ruleForm.attribution">
							<el-radio label="1">个人</el-radio>
							<el-radio label="2">单位</el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="抬头名称" prop="invoiceTitle">
						<el-input type="text" v-model="ruleForm.invoiceTitle" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="公司税号" prop="taxpayerNumber" v-if="ruleForm.type==3||ruleForm.attribution==2">
						<el-input type="text" v-model="ruleForm.taxpayerNumber" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="注册地址" prop="address" v-if="ruleForm.type==3">
						<el-input type="text" v-model="ruleForm.address" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="注册电话" prop="tel" v-if="ruleForm.type==3">
						<el-input type="text" v-model="ruleForm.tel" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="开户银行" prop="bank" v-if="ruleForm.type==3">
						<el-input type="text" v-model="ruleForm.bank" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="银行账号" prop="bankAccountNum" v-if="ruleForm.type==3">
						<el-input type="text" v-model="ruleForm.bankAccountNum" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="收票人姓名" prop="invoiceName" v-if="ruleForm.type !=1">
						<el-input type="text" v-model="ruleForm.invoiceName" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="收票人手机号" prop="invoiceTel" v-if="ruleForm.type !=1">
						<el-input type="text" v-model="ruleForm.invoiceTel" autocomplete="off"></el-input>
					</el-form-item>
					<!-- <el-form-item label="收票地址" prop="invoiceAddress">
                 <el-cascader
                   v-model="invoiceAddress"
                   ref="cascaderAddr"
                   class="cascaderArea"
                   placeholder="收货地址"
                   :props="{ checkStrictly: true }"
                   :options="getprovince"
                   @change="areaHandleChange"
                 >
                 </el-cascader>
              </el-form-item> -->
					<el-form-item label="收票详细地址" prop="invoiceAddress" v-if="ruleForm.type !=1">
						<el-input type="text" v-model="ruleForm.invoiceAddress" autocomplete="off"></el-input>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" size="mini" :disabled="comfiremdisabled" @click="submintAddress()"
							class="buttonBgd">确 定</el-button>
					</el-form-item>
				</el-form>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import axios from 'axios'
	import Pagination from '@/components/Pagination'
	import {
		searchOrder,
		showorderList,
		cancleOrderItem,
		removeOrderItem,
		payStatus,
		xy_personvalue,
		confirmRceiptItem,
		address_add,
		invoiceList,
		invoiceAdd,
		invoiceDel,
		invoiceDetail,
		getAfterSaleschatpoople,
		getoldmessage
	} from '@/api/xunyou';
	import Vue from 'vue';
	export default {
		data() {
			return {
				userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
				loading: false,
				activeName: 0,
				searchValue: '',
				orderInfoList: [],
				closeValue: '',
				finishiValue: '',
				waitGetValue: '',
				waitSendValue: '',
				waitpayValue: '',
				allValue: '',
				// 请求数据参数
				formInline: {
					pageSize: 10,
					pageNum: 1,
					status: 0,
					title: '',
					muid: JSON.parse(localStorage.getItem("userdata")).userId,
				},
				// 分页参数
				pageparm: {
					pageSize: 10,
					currentPage: 1,
					total: 0,
				},

				comfiremdisabled: false,
				dialogInvoice: false,
				showEditButtom: false,
				invoiceData: {},
				orderDatail: {}, //订单信息
				ruleForm: {
					muid: JSON.parse(localStorage.getItem("userdata")).userId,
					recipient: "",
					phoneNumber: "",
					areaid: "",
					address: "",
					postalCode: "",
					defaultAddress: 0,

					type: "2",
					attribution: "1",
					invoiceTitle: '',
					taxpayerNumber: '', //税号
					address: '', //注册地址
					tel: '',
					bankAccountNum: '', //银行账号
					bank: '',
					invoiceName: '', //收票人姓名
					invoiceTel: '', //收票人手机号
					invoiceAddress: '', //收票地址
					invoiceData: {
						type: 1,
						attribution: 1
					},


				},
				rules: {
					recipient: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					phoneNumber: [{
						required: true,
						trigger: ["blur", "change"],
						validator: (rule, value, callback) => {
							if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(value)) {
								callback(new Error('请输入正确的手机号码'));
							} else {
								callback();
							}
						}
					}, ],
					areaid: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],

					invoiceTitle: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					taxpayerNumber: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					address: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					tel: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					bank: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					bank: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					bankAccountNum: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					invoiceName: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					recipient: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					invoiceTel: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],
					invoiceAddress: [{
						required: true,
						message: "不能为空,请输入",
						trigger: ["blur", "change"],
					}, ],


				},
				gifarr: [{
						"img": "0.gif",
						"id": 0
					},
					{
						"img": "1.gif",
						"id": 1
					},
					{
						"img": "2.gif",
						"id": 2
					},
					{
						"img": "3.gif",
						"id": 3
					},
					{
						"img": "4.gif",
						"id": 4
					},
					{
						"img": "5.gif",
						"id": 5
					},
					{
						"img": "6.gif",
						"id": 6
					},
					{
						"img": "7.gif",
						"id": 7
					},
					{
						"img": "8.gif",
						"id": 8
					},
					{
						"img": "9.gif",
						"id": 9
					},
					{
						"img": "10.gif",
						"id": 10
					},
					{
						"img": "11.gif",
						"id": 11
					},
					{
						"img": "12.gif",
						"id": 12
					},
					{
						"img": "13.gif",
						"id": 13
					},
					{
						"img": "14.gif",
						"id": 14
					},
					{
						"img": "15.gif",
						"id": 15
					},
					{
						"img": "16.gif",
						"id": 16
					},
					{
						"img": "17.gif",
						"id": 17
					},
					{
						"img": "18.gif",
						"id": 18
					},
					{
						"img": "19.gif",
						"id": 19
					},
					{
						"img": "21.gif",
						"id": 20
					},
					{
						"img": "22.gif",
						"id": 21
					},
					{
						"img": "23.gif",
						"id": 23
					},
					{
						"img": "24.gif",
						"id": 24
					},
					{
						"img": "25.gif",
						"id": 25
					},
					{
						"img": "26.gif",
						"id": 26
					},
					{
						"img": "27.gif",
						"id": 27
					},
					{
						"img": "28.gif",
						"id": 28
					},
					{
						"img": "29.gif",
						"id": 29
					},
					{
						"img": "30.gif",
						"id": 30
					},
					{
						"img": "31.gif",
						"id": 31
					},
					{
						"img": "32.gif",
						"id": 32
					},
					{
						"img": "33.gif",
						"id": 33
					},
					{
						"img": "34.gif",
						"id": 34
					},
					{
						"img": "35.gif",
						"id": 35
					},
					{
						"img": "36.gif",
						"id": 36
					},
					{
						"img": "37.gif",
						"id": 37
					},
					{
						"img": "38.gif",
						"id": 38
					},
					{
						"img": "39.gif",
						"id": 39
					},
					{
						"img": "40.gif",
						"id": 40
					},
				],
				// emojiMap: {
				// 	"微笑": "<img src='../../../static/layui/images/face/0.gif'/>",
				// 	"嘻嘻": "<img src='../../../static/layui/images/face/1.gif'/>",
				// 	"哈哈": "<img src='../../../static/layui/images/face/2.gif'/>",
				// 	"可爱": "<img src='../../../static/layui/images/face/3.gif'/>",
				// 	"可怜": "<img src='../../../static/layui/images/face/4.gif'/>",
				// 	"挖鼻": "<img src='../../../static/layui/images/face/5.gif'/>",
				// 	"吃惊": "<img src='../../../static/layui/images/face/6.gif'/>",
				// 	"害羞": "<img src='../../../static/layui/images/face/7.gif'/>",
				// 	"挤眼": "<img src='../../../static/layui/images/face/8.gif'/>",
				// 	"闭嘴": "<img src='../../../static/layui/images/face/9.gif'/>",
				// 	"鄙视": "<img src='../../../static/layui/images/face/10.gif'/>",
				// 	"爱你": "<img src='../../../static/layui/images/face/11.gif'/>",
				// 	"泪": "<img src='../../../static/layui/images/face/12.gif'/>",
				// 	"偷笑": "<img src='../../../static/layui/images/face/13.gif'/>",
				// 	"亲亲": "<img src='../../../static/layui/images/face/14.gif'/>",
				// 	"生病": "<img src='../../../static/layui/images/face/15.gif'/>",
				// 	"太开心": "<img src='../../../static/layui/images/face/16.gif'/>",
				// 	"白眼": "<img src='../../../static/layui/images/face/17.gif'/>",
				// 	"右哼哼": "<img src='../../../static/layui/images/face/18.gif'/>",
				// 	"左哼哼": "<img src='../../../static/layui/images/face/19.gif'/>",
				// 	"嘘": "<img src='../../../static/layui/images/face/20.gif'/>",
				// 	"衰": "<img src='../../../static/layui/images/face/21.gif'/>",
				// 	"委屈": "<img src='../../../static/layui/images/face/22.gif'/>",
				// 	"吐": "<img src='../../../static/layui/images/face/23.gif'/>",
				// 	"哈欠": "<img src='../../../static/layui/images/face/24.gif'/>",
				// },
				emojiMap: {
					"微笑": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/ebb0d566983e98b207de65928466724c.gif'/>",
					"嘻嘻": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/cfd6c724034619e463343bdd18ae2054.gif'/>",
					"哈哈": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/398e9cfe007561f3d843403eb5223fc3.gif'/>",
					"可爱": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/326dfc753bdabab5a1078d72aad8a831.gif'/>",
					"可怜": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/d0c3837063bbbfe04e1d61db168b5fa8.gif'/>",
					"挖鼻": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/6c71b664cd42b83830cf33ed75587cbf.gif'/>",
					"吃惊": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/4c1f8f268a7d5e34822cd91c261e9b33.gif'/>",
					"害羞": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/2f447e6e2e3b40449e878bc864e2b6b0.gif'/>",
					"挤眼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/b21becfa700641dba951c13ade328b08.gif'/>",
					"闭嘴": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/4909784c09bb0d34af9ec6bee01366c3.gif'/>",
					"鄙视": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/05697b2d1b83b15dfcee51a138a29a9d.gif'/>",
					"爱你": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/47a9dd92fa80420b2ed1488602a94c0d.gif'/>",
					"泪": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/1679327e411f27f4a2547d989fe982cd.gif'/>",
					"偷笑": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/c4ad86f411946e1c3212484de93ff917.gif'/>",
					"亲亲": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/0310ff823298f496eda6e7bdaabff5ed.gif'/>",
					"生病": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/931ff97c7dd2d7cbfe6daa16438101a6.gif'/>",
					"太开心": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/4217bf643e720b630bfa7392fc04c94a.gif'/>",
					"白眼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/11e6eb949ad17c9a6c9abdc26b3cdb5a.gif'/>",
					"右哼哼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/8b0d7edd4bb6fb060a5c998cff3d19e0.gif'/>",
					"左哼哼": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/f521f84d27e2b177df3875ee6c9cecb2.gif'/>",
					"嘘": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/046f92526c6d5ca3c0381fd5033dfd2f.gif'/>",
					"衰": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/d8a903b5d37d761a8052e554ff8bb8ac.gif'/>",
					"委屈": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/60870d59c32d212b3b7fd6be178d8eba.gif'/>",
					"吐": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/14529d0d77475573031afb7eb1277864.gif'/>",
					"哈欠": "<img src='https://www.nays.com.cn/center/profile/upload/2024/01/17/af7466b790e90e12d217f489af44b8c6.gif'/>",
				},
				setInterval: null,
				kfname: null, // 客服名称
				loadingdialog: false, // loading效果
				isshowminicard: true, // 小卡片的显示隐藏
				userid: null,
				id: localStorage.getItem('userdata'),
				socket: null,
				from: {}, // 收发人信息
				goodspart: {}, // 点击咨询时的小卡片信息
				isdisplay: false, // 是否显示发送表情模块
				messageText: '', // 聊天框内容
				messages: [], // 聊天所有数据
				dialogVisible: false,
			};
		},
		// 注册组件
		components: {
			Pagination
		},
		/**
		 * 数据发生改变
		 */

		/**
		 * 创建完毕
		 */
		created() {
			this.userid = JSON.parse(this.id).userId
		},
		mounted() {
			if (this.$route.fullPath.indexOf('tap') > 0) {
				this.activeName = this.$route.query.tap
			}

			if (this.$route.fullPath.indexOf('orderNumer') > 0) {
				this.getPayStatus()
				//   this.getshoworderList(this.activeName)
			} else {
				this.getshoworderList(this.activeName)
			}
		},
		destroyed() {
			this.socket.close(); //断开websocket连接
			clearInterval(this.setInterval)
		},
		/**
		 * 里面的方法只有被调用才会执行
		 */
		methods: {

			// 点击上传图片
			shangchuanimgfn() {
				this.$refs.files.click()
			},
			// 选中图片状态改变
			handleFileChange(event) {
				const file = event.target.files[0];
				if (file) {
					// 执行图片上传的操作
					console.log('Selected file:', file.type);
					this.uploadFileimg(file);

				}
			},
			// 发图片
			uploadFileimg(file) {
				const formData = new FormData();
				formData.append('file', file);
				// console.log(`http://192.168.0.148:8080/api/common/upload/chatFile`);
				axios.post(`${Vue.prototype.$imUrl}/api/common/upload/chatFile`, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						},
					})
					.then(res => {
						console.log('Upload successful 图片', res.data.url);
						if (res.data.url) {
							let url = {
								"url": res.data.url.toString()
							}
							this.addMessage(1, url)
						}
					})
					.catch(error => {
						console.error('Error uploading file 图片', error);
					});
			},


			// 点击上传视频
			shangchuanmp4fn() {
				this.$refs.mp4files.click()
			},
			// 选中视频状态改变
			handleFileMP4Change(event) {
				const file = event.target.files[0];
				if (file) {
					// 执行图片上传的操作
					console.log('Selected file:', file.type);
					this.uploadFileMP4(file);

				}
			},
			// 发视频
			uploadFileMP4(file) {
				const formData = new FormData();
				formData.append('file', file);
				// console.log(`http://192.168.0.148:8080/api/common/upload/chatFile`);
				axios.post(`${Vue.prototype.$imUrl}/api/common/upload/chatFile`, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						},
					})
					.then(res => {
						console.log('Upload successful 视频', res.data.url);
						if (res.data.url) {
							let url = {
								"src": res.data.url.toString()
							}
							this.addMessage(5, url)
						}
					})
					.catch(error => {
						console.error('Error uploading file 视频', error);
					});
			},




			// 文字中的表情包
			textfaceimg(face) {
				let that = this
				// var text = "这是一段包含 face[微笑]、face[大笑] 和 face[开心] 的文字";
				var replacedText = face.replace(/face\[(.*?)\]/g, function(match, p1) {
					if (that.emojiMap[p1]) {
						return that.emojiMap[p1];
					} else {
						return match;
					}
				});
				return replacedText
			},
			// 点击发送进行商品的发送,单商品咨询
			onegoodschat() {
				console.log("是否拿到orderNumber", this.goodspart);
				this.addMessage(3, JSON.stringify(this.goodspart))
				this.isshowminicard = false
				this.goodspart = {}
			},
			// 点击表情包
			clickimg(e) {
				this.addMessage(4, e)
			},
			// 判断是哪一个gif
			giffn(e) {
				// console.log( `../../../static/layui/images/face/${e}`);
				return require(`../../../static/layui/images/face/${e}`)
			},
			// 点击发送信息
			addMessage(msgtype, content) {
				let fromlist = {}
				if (msgtype == 3) {
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: "4",
							extend: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				} else if (msgtype == 1) {
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: "4",
							extend: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				} else if (msgtype == 5) {
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: "4",
							extend: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包 5视频
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				} else {
					fromlist = {
						code: "2",
						message: {
							chatId: this.from.fromId,
							chatType: "4",
							content: content,
							fromId: this.from.userId,
							messageType: msgtype + '', // 0文本， 1图片 2压缩包文件 3商品 4表情包
							mine: true,
							timestamp: new Date(),
							type: "0"
						}
					}
				}
				this.socket.send(JSON.stringify(fromlist));
				this.messageText = '';
				// console.log('点击发送了');
			},
			// 点击联系客服
			ToChat(items, item) {
				console.log("订单详情123456789", item);
				this.goodspart = {
					"id": items[0].id,
					"image": items[0].photos,
					"goodsname": items[0].name,
					"price": items[0].realprice,
					"orderNumber": item.orderNumber
				} // 拿到小卡片的数据
				this.isshowminicard = true
				this.dialogVisible = true // 打开聊天框
				this.isdisplay = false // 关闭表情包窗口
				// 获取收发人id
				getAfterSaleschatpoople(JSON.parse(this.id).userId, JSON.parse(this.id).roleId, "4").then((res) => {
					// 后端遗留问题 : 如果a客服休息一天,甲用户和b聊,那么a 上线时会和ab来回切换聊 bug
					console.log("双方id", res);
					if (res.code == 500) {
						this.$message.error(res.msg);
						return
					} else {
						this.kfname = res.data.name
						this.from = {
							userId: res.data.userId,
							fromId: res.data.fromId
						}
						this.getoldmsg(res.data.userId, res.data.fromId)
					}
				})
				if (this.socket) return
				this.socket = new WebSocket(`${Vue.prototype.$wsUrl}/?token=${JSON.parse(this.id).userId}`);
				this.socket.onopen = (e) => {
					console.log('scoket链接成功!');
					this.setInterval = setInterval(() => {
						console.log('心跳开启');
						this.socket.send(JSON.stringify({
							code: 0
						}));
					}, 10000)
					this.socket.send(JSON.stringify({
						code: 1
					}));
				};

				this.socket.onclose = (event) => {
					if (event.wasClean) {
						console.log(`scoket关闭, code=${event.code} reason=${event.reason}`);
					} else {
						// 例如服务器进程被杀死或网络中断
						// 在这种情况下，event.code 通常为 1006
					}
				};

				this.socket.onerror = (error) => {
					console.log(`scoket异常 ${error.message}`);
				};


				this.socket.onmessage = (event) => {
					console.log(`收到消息: ${event.data}`);
					// console.log('转换完了', JSON.parse(event.data).message.content);
					// console.log("code为:", JSON.parse(event.data).code);
					if (JSON.parse(event.data).code == 0) {
						console.log("停止");
						return
					}
					if (JSON.parse(event.data).code == 4) {
						this.kfname = JSON.parse(event.data).message.name
						this.from.fromId = JSON.parse(event.data).message.chatId.toString() // 新客服id
						if (true) {
							this.messageText = "----聊天状态已改变,请注意查收新消息!----"
							this.addMessage(0, JSON.stringify(this.messageText))
						}
					}
					if (JSON.parse(event.data).code == 5) {
						// this.$message({
						// 	message: '客服已读!',
						// 	type: 'success'
						// });
						this.messages.forEach(item => {
							item.readState = 'true'
						})
					}
					if (JSON.parse(event.data).message.messageType == 0) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							content: JSON.parse(event.data).message.content,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("文字push成功");
					} else if (JSON.parse(event.data).message.messageType == 3) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							extend: JSON.parse(event.data).message.extend,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("卡片push成功");
					} else if (JSON.parse(event.data).message.messageType == 1) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							extend: JSON.parse(event.data).message.extend,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("图片push成功");
					} else if (JSON.parse(event.data).message.messageType == 5) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							extend: JSON.parse(event.data).message.extend,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("视频push成功");
					} else if (JSON.parse(event.data).message.messageType == 4) {
						this.messages.push({
							readState: '',
							messageType: JSON.parse(event.data).message.messageType,
							content: JSON.parse(event.data).message.content,
							fromId: JSON.parse(event.data).message.fromId + '',
							avatar: JSON.parse(event.data).message.fromId + '' == this.userid ? JSON.parse(this
									.id).avatar :
								'https://tse1-mm.cn.bing.net/th/id/OIP-C.1t2MobIQJZnthL-k7lBZEgAAAA?pid=ImgDet&rs=1'
						});
						// console.log("表情包push成功");
					}
					this.$nextTick(() => {
						let scrollElem = document.getElementById('message-list');
						scrollElem.scrollTo({
							top: scrollElem.scrollHeight,
							behavior: 'smooth'
						});
					});
				};
				setInterval(() => {
					this.isshowminicard = false
				}, 8000)
			},
			// 获取聊天记录
			getoldmsg(u, c) {
				// console.log("进入了历史记录:",u, c);
				const page = {
					chatId: c,
					fromId: u,
					chatType: "0", // 0是单聊
					messageType: " ", // 不传为获取所以类型的历史记录
					current: "1",
					size: "40"
				}
				this.loadingdialog = true // 开启loading
				getoldmessage(page).then((res) => {
					// console.log("正确的历史信息：",...res.data.records);
					// this.messages = [...res.data.records].reverse()
					this.messages = [...res.data]
					console.log(this.messages);
					this.$nextTick(() => {
						let msg = document.getElementById('message-list') // 获取对象
						msg.scrollTop = msg.scrollHeight // 滚动高度
					})
					this.loadingdialog = false // 关闭loading
				}).catch((req) => {
					console.log("错误信息", req);
				})
			},
			//   新增发票
			submintAddress(item) {
				//   console.log(editReq,'xiugai1')
				this.$refs.ruleForm.validate((valid) => {
					this.ruleForm.order_id = this.orderDatail.oid;
					this.ruleForm.mid = this.orderDatail.bxmId;


					this.ruleForm.uid = this.userInfo.userId;
					this.ruleForm.defaultAddress = this.ruleForm.defaultAddress ? 1 : 0;
					if (valid) {
						this.comfiremdisabled = true;
						invoiceAdd(this.ruleForm)
							.then((res) => {
								if (res.code == 0) {
									this.dialogVisible = false;
									this.ruleForm = {};
									this.getinvoiceList();
									this.comfiremdisabled = false;
									this.$message({
										type: "info",
										message: res.msg,
									});
								} else {
									this.$message({
										type: "info",
										message: res.msg,
									});
									this.comfiremdisabled = false;
								}
							})
							.catch((err) => {
								this.dialogVisible = false;
								this.$message.error("提交失败，请稍后再试！");
							});
					}
				});
			},
			// 新增发票窗口
			addinvoice(e) {
				console.log('---1');
				this.dialogInvoice = true;
				this.orderDatail = e
			},
			beforeClose() {
				this.invoiceData = {};
				this.dialogInvoice = false;
			},
			// 分页插件事件
			callFather(parm) {
				this.formInline.pageNum = parm.currentPage
				this.formInline.pageSize = parm.pageSize
				this.getshoworderList(this.activeName)
			},
			// // 查询支付状态
			getPayStatus() {
				payStatus({
						out_trade_no: this.$route.query.orderNumer
					})
					.then(res => {
						// console.log('res路径',res,res.alipay_trade_query_response.code==10000 , res.alipay_trade_query_response.trade_status=='TRADE_SUCCESS')
						if (res.alipay_trade_query_response.code == 10000 && res.alipay_trade_query_response
							.trade_status == 'TRADE_SUCCESS') {
							// console.log('杨老板接口进来了吗')
							xy_personvalue({
									orderId: this.$route.query.orderNumer // 这个需要处理重新获值
								})
								.then(res => {
									// console.log(res,'杨老板接口进来了吗')
									this.getshoworderList(this.activeName)
									// this.$message.error('调取失败失败，请稍后再试！')
								})
								.catch(err => {
									this.$message.error('查询失败，请稍后再试！')
								})
						}
					})
					.catch(err => {

					})
			},
			//   切换tab
			tabhandleClick(tab, event) {
				// getshoworderList
				console.log(this.activeName, tab, event, 'tab切换');
				this.getshoworderList(this.activeName)
				//    this.getshoworderList(1);
			},

			// 订单查询
			getshoworderList(status, value) {
				this.loading = true
				this.formInline.status = status == 0 ? '' : status
				this.formInline.title = value || '';
				this.formInline.uid = this.userInfo.userId || "";
				//  status = status==0?'':status
				//     {
				//     status:status,
				//     title:value || '',
				//     muid:this.userInfo.userId,
				// }
				showorderList(this.formInline)
					.then(res => {
						if (res.code == 0) {
							this.loading = false
							this.orderInfoList = res.rows
							this.orderInfoList.forEach((item) => {
								item.totalMoney = (Number(item.amount) + Number(item.transportfee)).toFixed(2)
							})
							console.log(this.orderInfoList, 'ccc123');
							// 分页赋值
							this.pageparm.currentPage = this.formInline.pageNum
							this.pageparm.pageSize = this.formInline.pageSize
							this.pageparm.total = res.total
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.loading = false
						this.$message.error('查询红包失败，请稍后再试！')
					})
			},

			//   订单状态转换
			orderStatus(status) {
				switch (status) {
					case 1:
						return '等待买家付款'
						break;
					case 2:
						return '等待卖家发货'
						break;
					case 3:
						return '等待买家确认收货'
						break;
					case 4:
						return '交易成功'
						break;
					case 5:
						return '交易关闭'
						break;
					case 11:
						return '买家提交退单'
						break;
					case 12:
						return '退单审核中'
						break;
					case 13:
						return '等待卖家收货确认'
						break;
					case 14:
						return '等待卖家退款确认'
						break;
					case 15:
						return '等待买家收款确认'
						break;
					case 16:
						return '退款完成'
						break;
					case 17:
						return '已拒绝退款'
						break;
					case 18:
						return '已取消'
						break;
					case 31: //交易成功，未返修
						return '已申请返修'
						break;
					case 32: //交易成功，返修审核
						return '返修审核'
						break;
					case 33: //交易成功，返修完成
						return '返修完成'
						break;
					case 34: //交易成功，返修寄回
						return '返修寄回'
						break;
					default:
						return '--'
				}
			},

			// 搜索功能
			searchHandle(value) {
				this.getshoworderList(this.activeName, value)
			},

			// 确认收货
			confirmRceipt(item) {
				confirmRceiptItem({
						oid: item.oid,
						orderNumber: item.orderNumber
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '确认收货成功!'
							});
							this.getshoworderList(this.activeName)
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.editFormVisible = false
						this.loading = false
						this.$message.error('确认收货失败，请稍后再试！')
					})
			},

			// 订单详情
			gotoDetail(item) {
				console.log(item, '订单详情')
				sessionStorage.setItem("orderDetail", JSON.stringify(item));
				this.$router.push('/myOrderDetail')
			},
			//申请返修
			rework(item) {
				sessionStorage.setItem("orderDetail", JSON.stringify(item));
				this.$router.push('/rework')
			},
			// 立即支付
			payOrderNow(amount, orderGoodsInfo) {
				console.log(amount, orderGoodsInfo, 'ccc');
				sessionStorage.setItem("account", JSON.stringify(Number(amount) + Number(orderGoodsInfo.transportfee)));
				orderGoodsInfo.title = orderGoodsInfo.commodityName
				orderGoodsInfo.amount = Number(amount) + Number(orderGoodsInfo.transportfee)
				sessionStorage.setItem("orderGoodsInfo", JSON.stringify([orderGoodsInfo]));
				this.$router.push('/orderNow')
			},
			refund(e) {
				console.log(e);
				const myRefundInfo = {
					oid: e.oid,
					bXyOasid: '',
					returnType: '',
					orderNumber: e.orderNumber,
					amount: e.totalMoney,
					goodsItem: e.bxyCommodityList,
				}
				sessionStorage.setItem('myRefundInfo', JSON.stringify(myRefundInfo))
				this.$router.push('/myRefund?status=1')
			},
			//   取消订单
			cancleOrder(orderId) {
				this.$confirm('确定取消订单?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					cancleOrderItem({
							oid: orderId
						}).then(res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '取消成功!'
								});
								this.getshoworderList(this.activeName)
							} else {
								this.$message({
									type: 'info',
									message: res.msg
								})
							}
						})
						.catch(err => {
							this.editFormVisible = false
							this.loading = false
							this.$message.error('查询红包失败，请稍后再试！')
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},

			// 订单评价
			orderEvaluation(item) {
				this.$router.push(`/orderAppraisal?orderNumber=${item.orderNumber}`)
				//  $router.push(`/gotoEvaluation?orderNumber=${item.orderNumber}`)
			},

			//   移出订单
			removeOrder(orderId) {
				this.$confirm('确定移除订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					removeOrderItem({
							oid: orderId
						}).then(res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '移除成功!'
								});
								this.getshoworderList(this.activeName)
							} else {
								this.$message({
									type: 'info',
									message: res.msg
								})
							}
						})
						.catch(err => {
							this.editFormVisible = false
							this.loading = false
							this.$message.error('移除失败，请稍后再试！')
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已移除'
					});
				});
			},

			nextEditResource() {
				this.$refs.sizeForm.validate((valid) => {
					if (valid) {
						if (this.sizeForm.checkedBox) {
							this.errerInfo = false;
							this.$router.push(`/merchantForm?type=${this.$route.query.type}`)
						} else {
							this.errerInfo = true;
						}
					}
				});
			}

		},
	};
</script>

<style scoped lang="less">
	// .rightaside{
	//     background: white;
	//     margin-left: 15px;
	//     padding: 20px !important;
	.rightaside_content {
		.headerTitle {
			font-size: 20px;
			height: 40px;
			line-height: 40px;
			color: #666;
		}

		/deep/.el-tabs--border-card {
			border: 0px;
			box-shadow: unset;

			.el-tabs__header {
				border-bottom: 0px;
				background: white;

				/deep/ .el-tabs__item.is-active {
					color: #ff6700;
					background-color: transparent;
					border-right-color: transparent;
					border-left-color: transparent;
				}
			}
		}

		.search_box {
			text-align: right;
			margin-bottom: 10px;

			.input-with-select.el-input.el-input-group.el-input-group--append {
				width: 40%;
			}
		}

		.redBorder {
			border: 1px solid #ff6700 !important;
		}

		.orderbox_info {
			// padding: 20px;
			// box-sizing: border-box;
			margin-bottom: 10px;
			border: 1px solid#ccc;

			.orderbox_info_header {
				padding: 20px;
				box-sizing: border-box;
				border-bottom: 1px solid #ccc;
				display: flex;
				justify-content: space-between;

				p {
					font-size: 16px;
					color: #ff6700;
					margin-bottom: 5px;
				}

				.order_money i {
					font-size: 20px;
					color: #ff6700;
				}
			}

			.order_goods_whole {
				padding: 20px;
				box-sizing: border-box;

				.order_goods {
					margin-bottom: 20px;

					.order_Info_item {
						margin-left: 20px;
					}
				}

				button.el-button.buttonStyle {
					padding: 6px 30px;
					font-size: 12px;
					margin-bottom: 6px;
					margin-left: 0;
					min-width: 110px;
				}

				.dangerBg.buttonStyle {
					background-color: #ff6700;
					border-color: #ff6700;
				}

				.el-button--danger.is-plain {
					background: white;
				}

				.el-button--danger:focus,
				.el-button--danger:hover {
					color: white;
					background: #F56C6C;
				}
			}
		}

		.tab_pane_content {
			.noData {
				text-align: center;
				height: 200px;
				line-height: 200px;
			}
		}

	}

	// }
	.pagination {
		text-align: right;

		/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #ff6700;
			color: #FFF;
			width: 20px;
		}

		/deep/.el-pagination.is-background .btn-next,
		/deep/.el-pagination.is-background .btn-prev,
		/deep/.el-pagination.is-background .el-pager li {
			width: 20px;
		}

		/deep/input[disabled],
		input[disabled="disabled"],
		input[readonly],
		input[readonly="readonly"] {
			background-color: transparent;
		}
	}




	.dialogContent {
		height: 500px;
	}

	/deep/.el-dialog__body {
		padding: 10px 5px !important;
		color: #606266;
		font-size: 14px;
		word-break: break-all;
	}

	.chat-box {
		display: flex;
		flex-direction: column;
		height: 100%;
		width: 100%;
		margin: 0 auto;
		border: 0px;
	}

	#message-list {
		flex: 1;
		overflow-y: auto;
	}

	.leftmessage {
		display: flex;
		flex-direction: column;
		margin: 4px 0;
		width: 100%;
		min-height: 50px;
		font-size: 14px;
		position: relative;

		.divtext {
			padding: 0 50px;
		}

		.divimg {
			height: 30px;
			padding: 0 15px;

			img {
				width: 30px;
				height: 30px;
			}
		}

		.divzt {
			position: absolute;
			color: #ccc;
			top: -5px;
			left: 50px;
		}

	}

	.rightmessage {
		display: flex;
		flex-direction: column;
		position: relative;
		margin: 4px 0;
		width: 100%;
		font-size: 14px;


		.divtext {
			padding: 0 50px;
			display: flex;
			justify-content: end;

			.minicard {
				padding-bottom: 15px;
				margin-right: 15px;
				width: 250px;
				height: 110px;
				background-color: #f1f1f1;
				border-radius: 8px;
				padding: 5px;
				display: flex;

				.left {
					flex: 1.5;
					background-color: #c4ffee;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.right {
					flex: 2;
					position: relative;

					.dianjifs {
						line-height: 25px;
						text-align: center;
						color: #dcdfe6;
						width: 75px;
						height: 25px;
						border-radius: 20px;
						background-color: #D33A31;
						transform: translateX(-50%);
						cursor: pointer;
					}

					span {
						font-size: 14px;
						transform: scale(0.8);
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
					}
				}


			}
		}

		.divimg {
			height: 30px;
			padding: 0 15px;
			display: flex;
			justify-content: end;

			img {
				width: 30px;
				height: 30px;
			}
		}
		.divzt {
			position: absolute;
			color: #ccc;
			top: -5px;
			right: 50px;
		}

	}

	.message-text {
		font-size: 14px;
	}

	.input-box {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 10px;
		border-top: 1px solid #ccc;
		position: relative;

		.imgbox {
			background-color: #eeeeee;
			width: 202px;
			height: 145px;
			position: absolute;
			top: -160px;
			left: 10px;
			border-radius: 5px;
			padding: 5px;
			box-sizing: border-box;
			overflow-y: auto;

			&::-webkit-scrollbar {
				display: none;
			}

			img {
				cursor: pointer;
				margin: 6px 5px;
			}
		}

		.minicard {
			width: 250px;
			height: 110px;
			background-color: #e7e7e7;
			border-radius: 8px;
			padding: 5px;
			position: absolute;
			top: -130px;
			right: 10px;
			display: flex;

			.left {
				flex: 1.5;
				background-color: #c4ffee;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.right {
				flex: 2;
				position: relative;

				.dianjifs {
					line-height: 25px;
					text-align: center;
					color: #dcdfe6;
					width: 75px;
					height: 25px;
					border-radius: 20px;
					background-color: #D33A31;
					position: absolute;
					bottom: 5px;
					left: 50%;
					transform: translateX(-50%);
					cursor: pointer;
				}

				span {
					font-size: 14px;
					transform: scale(0.8);
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}
			}

		}

		.textimgdiv {
			width: 100px;
			height: 30px;
			background-color: #ffffff;
			position: absolute;
			top: 0;
			left: 0;
			display: flex;
			// justify-content: space-around;
			justify-content: start;
			line-height: 25px;
			text-align: center;

			div {
				width: 40px;

				img {
					width: 20px;
					height: 20px;
					cursor: pointer;
				}
			}
		}
	}

	.input-box input {
		flex: 1;
		margin-right: 10px;
		padding: 25px 10px 0 10px;
		font-size: 14px;
		border-radius: 5px;
		border: none;
		outline: none;
	}

	.input-box button {
		padding: 6px 20px;
		font-size: 14px;
		font-weight: bold;
		border-radius: 5px;
		background-color: #d33a31;
		color: #fff;
		border: none;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	.input-box button:hover {
		background-color: #d33a31;
	}
</style>


// WEBPACK FOOTER //
// src/views/myOrder/myOrder.vue